export default __webpack_public_path__ + "63d6ebd4d68495ecfc9e7e72b08e30c4.svg";